import script from "./problemChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./problemChoice.vue?vue&type=script&setup=true&lang=js"

import "./problemChoice.vue?vue&type=style&index=0&id=0036827c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0036827c"]])

export default __exports__